<template>
  <div class="pay_way_area row">
    <div class="pay-way-title">付款方式</div>
    <div class="pay-way-title">線下</div>
    <!-- 1:現金 2:信用卡 3:匯款' -->
    <ul class="pay-way-list-all">
      <li class="square-radio">
        <input type="radio" v-model="payWay" value="1" id="cash" />
        <label for="cash">現金</label>
      </li>
      <li class="square-radio">
        <input type="radio" v-model="payWay" value="2" id="credit-card" />
        <label for="credit-card">信用卡</label>
      </li>
      <li class="square-radio">
        <input type="radio" v-model="payWay" value="3" id="line-pay" />
        <label for="line-pay">匯款</label>
      </li>
      <li class="square-radio">
        <input type="radio" v-model="payWay" value="4" id="coupon" />
        <label for="coupon">其他</label>
      </li>
    </ul>

    <!-- 新增線上購買 -->
    <div class="pay-way-title mt-3">線上</div>
    <div class="pay-way-online">
      <button class="online-purchase-btn" @click="handleOnlinePurchase">
        線上購買
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payment: {
      required: true,
      type: String
    }
  },
  computed: {
    payWay: {
      get() {
        return this.payment;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleOnlinePurchase() {
      this.$emit('online-purchase');
    }
  }
};
</script>
